module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "JSDecoderPlayerWind",
    staticClass: "JSDecoderPlayerWind",
    attrs: {
      "id": "JSDecoderPlayerWind"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d78db352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/JSDecoderPlayer.vue
// module id = 487
// module chunks = 1